import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=60a9ef32&scoped=true&"
import script from "./Waves.vue?vue&type=script&lang=js&"
export * from "./Waves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9ef32",
  null
  
)

export default component.exports